// src/theme.js
const theme = {
  primaryColor: '#3498db',
  primaryHoverColor: '#2980b9',
  secondaryColor: '#2ecc71',
  secondaryHoverColor: '#27ae60',
  textColor: '#333',
  backgroundColor: '#f5f5f5',
  fontFamily: 'Open Sans',
  borderRadius: '8px',
  padding: '16px',
  margin: '10px',
  headingFontSize: '30px',
  textFontSize: '16px',
};

export default theme;
